import {
  fetchListCity,
  fetchListDistrict,
  fetchListWard,
} from "@/apis/queryFunctions/address";
import { SelectComponent } from "@/common/components";
import useUserInfo from "@/hooks/useUserInfo";
import { CartContext } from "@/setup/cartProvider";
import { Button, Checkbox, SimpleGrid, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useCallback, useContext, useEffect, useState } from "react";

function FormAddress({ setIsShow, addressSelected }) {
  const { isLogin } = useUserInfo();
  const { submitAddress, setAddressSelected } = useContext(CartContext);
  const [listCity, setListCity] = useState([]);
  const [listDistrict, setListDistrict] = useState([]);
  const [listWard, setListWard] = useState([]);

  const form = useForm({
    initialValues: {
      ten_nguoi_nhan: "",
      sdt_nguoi_nhan: "",
      email_nguoi_nhan: "",
      tinh_thanh: "",
      quan_huyen: "",
      xa_phuong: "",
      dia_chi: "",
      ngam_dinh: false,
    },
    validate: {
      sdt_nguoi_nhan: (value) =>
        value.trim().length < 10 ? "Số điện thoại không hợp lệ" : null,
      email_nguoi_nhan: (value) => {
        if (!value.trim().length) return null;
        const isEmail = /\S+@\S+\.\S+/;
        return !isEmail.test(value) ? "Email không hợp lệ" : null;
      },
      tinh_thanh: (value) => (value ? null : "Vui lòng chọn tỉnh/thành phố"),
      quan_huyen: (value) => (value ? null : "Vui lòng chọn quận/huyện"),
      xa_phuong: (value) => (value ? null : "Vui lòng chọn xã/phường"),
      dia_chi: (value) => (value ? null : "Vui lòng nhập địa chỉ"),
    },
  });

  useEffect(() => {
    if (isLogin === false) {
      setAddressSelected({ ...form.values });
    }
  }, [form.values]);

  useEffect(() => {
    if (addressSelected?._id) {
      form.setFieldValue("ten_nguoi_nhan", addressSelected?.ten_nguoi_nhan);
      form.setFieldValue("sdt_nguoi_nhan", addressSelected?.sdt_nguoi_nhan);
      form.setFieldValue("dia_chi", addressSelected?.dia_chi);
      form.setFieldValue("email_nguoi_nhan", addressSelected?.email_nguoi_nhan);
      form.setFieldValue("tinh_thanh", addressSelected?.tinh_thanh);
      form.setFieldValue("quan_huyen", addressSelected?.quan_huyen);
      form.setFieldValue("xa_phuong", addressSelected?.xa_phuong);
      form.setFieldValue("ngam_dinh", addressSelected?.ngam_dinh);
      form.setFieldValue("id", addressSelected?._id);
    }
  }, [addressSelected]);

  useEffect(() => {
    const fetch = async () => {
      const res = await fetchListCity();
      res.sort((a, b) => {
        return a.ten_tinh_thanh.localeCompare(b.ten_tinh_thanh);
      });

      setListCity(res);
    };
    fetch();
  }, []);

  const fetchDistrict = useCallback(async (cityId) => {
    if (cityId) {
      const district = await fetchListDistrict(cityId);
      district?.sort((a, b) => {
        return a?.ten_quan_huyen.localeCompare(b?.ten_quan_huyen, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });
      setListDistrict(district);
    }
  }, []);

  const fetchWard = useCallback(async (district) => {
    if (district) {
      const listWard = await fetchListWard(district);
      listWard?.sort((a, b) => {
        return a?.ten_xa_phuong.localeCompare(b?.ten_xa_phuong, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });
      setListWard(listWard);
    }
  }, []);

  const selectProvince = async (value) => {
    form.setFieldValue("tinh_thanh", value);
    fetchDistrict(value);
  };

  const selectDistrict = async (value) => {
    form.setFieldValue("quan_huyen", value);
    fetchWard(value);
  };

  const selectWard = async (value) => {
    form.setFieldValue("xa_phuong", value);
  };

  // debounce set state

  const submitAddressSection = async (value) => {
    submitAddress(value);
    setIsShow(false);
  };

  return (
    <form
      onSubmit={form.onSubmit((values) => {
        submitAddressSection(values);
      })}
    >
      <TextInput
        {...form.getInputProps("ten_nguoi_nhan")}
        // value={userInfo?.ten_nguoi_nhan}
        label="Họ và tên"
        placeholder="Họ và tên"
        sx={{ marginBottom: 10 }}
      />
      <SimpleGrid sx={{ marginBottom: 10 }} cols={2}>
        <TextInput
          withAsterisk
          {...form.getInputProps("sdt_nguoi_nhan")}
          type="number"
          label="Số điện thoại"
          placeholder="Nhập số điện thoại"
        />
        <TextInput
          {...form.getInputProps("email_nguoi_nhan")}
          label="Địa chỉ email"
          placeholder="Địa chỉ email"
        />
      </SimpleGrid>
      <TextInput
        withAsterisk
        {...form.getInputProps("dia_chi")}
        sx={{ marginBottom: 10 }}
        label="Địa chỉ"
        placeholder="Địa chỉ nhận hàng"
      />
      <SimpleGrid
        cols={3}
        sx={{ marginBottom: 10 }}
        breakpoints={[
          {
            maxWidth: 1280,
            cols: 3,
            spacing: "sx",
          },
          {
            maxWidth: 980,
            cols: 1,
            spacing: "sx",
          },
        ]}
      >
        <SelectComponent
          formValidate={form.getInputProps("tinh_thanh")}
          required
          valueDefault={form.values?.tinh_thanh}
          data={listCity}
          valueKey="ten_tinh_thanh"
          labelKey="ten_tinh_thanh"
          label="Tỉnh thành phố"
          placeholder="Chọn tỉnh thành phố"
          onChange={selectProvince}
        />
        <SelectComponent
          formValidate={form.getInputProps("quan_huyen")}
          required
          valueDefault={form.values?.quan_huyen}
          data={listDistrict}
          valueKey="ten_quan_huyen"
          labelKey="ten_quan_huyen"
          label="Quân, huyện"
          placeholder="Chọn quận, huyện"
          onChange={selectDistrict}
        />
        <SelectComponent
          formValidate={form.getInputProps("xa_phuong")}
          required
          valueDefault={form.values?.xa_phuong}
          data={listWard}
          valueKey="ten_xa_phuong"
          labelKey="ten_xa_phuong"
          label="Phường xã"
          placeholder="Chọn phường xã"
          onChange={selectWard}
        />
      </SimpleGrid>

      {isLogin && (
        <>
          <Checkbox
            {...form.getInputProps("ngam_dinh")}
            sx={{ marginTop: 10 }}
            label="Địa chỉ giao hàng mặc định"
            checked={form.values.ngam_dinh}
            onChange={() => {
              form.setFieldValue("ngam_dinh", !form.values.ngam_dinh);
            }}
          />
          <Button sx={{ marginTop: 10 }} type="submit">
            Lưu địa chỉ
          </Button>
        </>
      )}
    </form>
  );
}

export default FormAddress;

// const styles = StyleSheet.create({});
